import React from "react";
import FooterAll from "../../components/Footer";

const Footer = () => {
  return <FooterAll />;
  
};

export default Footer;
